export default {
  'universal-layout.topmenu.userinfo': '個人信息',
  'universal-layout.topmenu.logout': '退出',

  'universal-layout.menu.home': '首頁',
  'universal-layout.menu.home.workplace': '工作臺',
  'universal-layout.menu.home.custom-breadcrumbs': '自定義面包屑',
  'universal-layout.menu.home.custom-breadcrumbs.liqingsong.cc': 'liqingsong.cc',
  'universal-layout.menu.home.docs': '使用文檔',

  'universal-layout.menu.component': '組件',
  'universal-layout.menu.component.icon': '圖標',
  'universal-layout.menu.component.icon.svg': 'IconSvg',
  'universal-layout.menu.component.icon.font': 'IconFont',
  'universal-layout.menu.component.editor': '編輯器',
  'universal-layout.menu.component.editor.tui-editor': 'tui-editor',
  'universal-layout.menu.component.editor.ckeditor': 'CKEditor',

  'universal-layout.menu.pages': '頁面示例',
  'universal-layout.menu.pages.list': '列表頁面',
  'universal-layout.menu.pages.list.basic': '標淮列表',
  'universal-layout.menu.pages.list.table': '表格列表',
  'universal-layout.menu.pages.list.highly-adaptive-table': '高度自適應表格',
  'universal-layout.menu.pages.list.search': '搜索列表',
  'universal-layout.menu.pages.list.search.table': '查詢表格',
  'universal-layout.menu.pages.form': '表單頁面',
  'universal-layout.menu.pages.form.basic': '基礎表單',
  'universal-layout.menu.pages.form.complex': '高級表單',
  'universal-layout.menu.pages.detail': '詳情頁面',
  'universal-layout.menu.pages.detail.basic': '基礎詳情',
  'universal-layout.menu.pages.detail.module': '模塊詳情',
  'universal-layout.menu.pages.detail.table': '表格詳情',

  'universal-layout.menu.roles': '權限驗證',
  'universal-layout.menu.roles.all': '用戶都有權限',
  'universal-layout.menu.roles.user': 'Users有權限',
  'universal-layout.menu.roles.test': 'Tests有權限',
};
